import api from '@/apis/dashboard/dashboardSurplusDeficitAPI';
import Chart from '@/stores/baseChart';
const chart = new Chart('surplusDeficit', api);
const state = {
  ...chart.state,
  colors: ['#0dbab6', '#ecbb4c', '#0eac13', '#ec6666'],
  avaChartColors: ['#0dbab6', '#ecbb4c', '#0eac13', '#ec6666'],
  categorieDatas: ['Doanh thu', 'Chi phí', 'Thặng dư', 'Thâm hụt'],
  avaChartCategorieDatas: ['Doanh thu', 'Chi phí', 'Thặng dư', 'Thâm hụt'],
  avaItems: [],
};
const getters = {
  ...chart.getters,
};
const actions = {
  ...chart.actions,
  /**
   * Load dữ liệu chart cho ava phân tích
   * @param {*} context context
   * @param {*} payload payload
   * NBTIN 03.06.2024
   */
  async avaLoad(context, payload) {
    let res = null;
    if (!api) {
      throw new Error('Chưa khai báo api');
    }
    if (typeof api.getChartDataMisaAva !== 'function') {
      throw new Error('Chưa định nghĩa hàm getChartDataMisaAva');
    }
    try {
      context.commit('updateLoading', true);
      res = await api.getChartDataMisaAva(payload || {});
      if (res && res.Data) {
        context.commit('setAvaItems', res.Data?.currentMonthData);
      } else {
        console.warn('Chart Data empty');
      }
    } finally {
      context.commit('updateLoading', false);
    }
    return res;
  },
  /**
   * Set items
   * @param {*} state state
   * @param {*} data data
   * NBTIN 03.06.2024
   */
  setAvaItems(context, payload) {
    context.commit('setAvaItems', payload);
  },
};
const mutations = {
  ...chart.mutations,
  /**
   * Set items
   * @param {*} state state
   * @param {*} data data
   * HTHIEP 21.06.2023
   */
  setItems(state, data) {
    let dataCustom = [];
    let colors = [];
    let categorieDatas = [];
    if(data && (data.Revenue != 0 || data.Expense != 0 || data.Excess != 0 || data.Deficit != 0) )
    {
      
      let datas = [data.Revenue,data.Expense,data.Excess,data.Deficit];
      datas = datas.filter(x => (x != 0 && x != null && x != undefined));
      dataCustom = [{data:datas}];
    }
    // gán dữ liệu load lên biểu đồ
    state.items = dataCustom;

    if(data.Revenue != null && data.Revenue != 0)
    {
      colors.push('#0dbab6');
      categorieDatas.push('Doanh thu');
    }

    if(data.Expense != null && data.Expense != 0)
    {
      colors.push('#ecbb4c');
      categorieDatas.push('Chi phí');
    }

    if(data.Excess != null && data.Excess != 0)
    {
      colors.push('#0eac13');
      categorieDatas.push('Thặng dư');
    }

    if(data.Deficit != null && data.Deficit != 0)
    {
      colors.push('#ec6666');
      categorieDatas.push('Thâm hụt');
    }

    // gán color và categories
    state.colors = [...colors];
    state.categorieDatas =  [...categorieDatas];
  },
  /**
   * Set items
   * @param {*} state state
   * @param {*} data data
   * HTHIEP 21.06.2023
   */
  setAvaItems(state, data) {
    let dataCustom = [];
    let avaChartColors = [];
    let avaChartCategorieDatas = [];
    if(data && (data.Revenue != 0 || data.Expense != 0 || data.Excess != 0 || data.Deficit != 0) )
    {
      
      let datas = [data.Revenue,data.Expense,data.Excess,data.Deficit];
      datas = datas.filter(x => (x != 0 && x != null && x != undefined));
      dataCustom = [{data:datas}];
    }
    // gán dữ liệu load lên biểu đồ
    state.avaItems = dataCustom;

    if(data.Revenue != null && data.Revenue != 0)
    {
      avaChartColors.push('#0dbab6');
      avaChartCategorieDatas.push('Doanh thu');
    }

    if(data.Expense != null && data.Expense != 0)
    {
      avaChartColors.push('#ecbb4c');
      avaChartCategorieDatas.push('Chi phí');
    }

    if(data.Excess != null && data.Excess != 0)
    {
      avaChartColors.push('#0eac13');
      avaChartCategorieDatas.push('Thặng dư');
    }

    if(data.Deficit != null && data.Deficit != 0)
    {
      avaChartColors.push('#ec6666');
      avaChartCategorieDatas.push('Thâm hụt');
    }

    // gán color và categories
    state.avaChartColors = [...avaChartColors];
    state.avaChartCategorieDatas =  [...avaChartCategorieDatas];
  },
};

export default {
  // eslint-disable-next-line no-undef
  debug: process.env.NODE_ENV !== 'production',
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
